import React, { type CSSProperties } from 'react';

import classnames from 'classnames';

import {
    Avatar,
    HighLight,
    Label,
    type SizeType,
    Small,
    Text,
    Tooltip,
    type TooltipProps
} from 'styled-system';

import styles from './Member.module.scss';

export type MemberProps = {
    appendName?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    email?: string;
    firstName?: string;
    highlight?: string;
    image?: string;
    lastName?: string;
    prependName?: React.ReactNode;
    size?: SizeType;
    style?: CSSProperties;
    suffix?: string;
    title?: string;
    tooltip?: Pick<TooltipProps, 'textAlignment' | 'title' | 'align' | 'placement'>;
    withInitials?: boolean;
    withEmail?: boolean;
    withEmailTooltip?: boolean;
    withTitle?: boolean;
    noPadding?: boolean;
};

export const Member = ({
    appendName,
    className,
    disabled,
    email,
    firstName,
    highlight,
    image,
    lastName,
    prependName,
    size,
    style,
    suffix,
    title,
    tooltip,
    withInitials = true,
    withEmail,
    withEmailTooltip = true,
    withTitle,
    noPadding
}: MemberProps) => {
    const name = `${firstName} ${lastName}`;
    return (
        <span className={classnames(styles.row, { [styles.noPadding]: noPadding })}>
            <Avatar alt={name} withInitials={withInitials} size={size} image={image} />
            <Tooltip
                align={tooltip?.align}
                disabled={disabled}
                placement={tooltip?.placement}
                textAlignment={tooltip?.textAlignment}
                title={tooltip?.title}
            >
                {prependName}
                <Text disabled={disabled} className={classnames(styles.text, className)}>
                    <span className={styles.name} style={style}>
                        <HighLight
                            className={styles.name}
                            text={name}
                            highlight={highlight}
                            suffix={suffix}
                        />
                    </span>
                    {withTitle && !!title && (
                        <Label className={styles.title}>
                            <Small>{title}</Small>
                        </Label>
                    )}
                    {withEmail && !!email && (
                        <Tooltip hidden={!withEmailTooltip} title={email}>
                            <Label className={styles.email}>
                                <HighLight text={email} highlight={highlight} />
                            </Label>
                        </Tooltip>
                    )}
                </Text>
                {appendName}
            </Tooltip>
        </span>
    );
};
